// extracted by mini-css-extract-plugin
export var articleDate = "news-module--article-date--7dx1q";
export var articleImage = "news-module--article-image--lR24+";
export var articleItem = "news-module--article-item--Z5fIa";
export var news = "news-module--news--73axG";
export var newsItem = "news-module--news-item--PB4jD";